import React, { useEffect, useState } from "react";
import {
  KioskProvider,
  KioskContextProps,
  FirebaseProvider,
  AnalyticsProvider,
} from "@popped/popshap-kiosk-components";


import { Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";

import "./styles/app.scss";
import { DataProvider } from "./context/DataProvider";
import LandingPage from "./pages/LandingPage";
import { Header } from "./components/Header";
import KitchenPage from "./pages/CampusDining/Kitchen";
import EatecFPage from "./pages/Solutions/Eatec";
import DigitalMenuFPage from "./pages/Solutions/DigitalMenu";
import IGKDSFPage from "./pages/Solutions/IGKDS";
import IGKioskFPage from "./pages/Solutions/IGKiosk";
import IGOnDemandFPage from "./pages/Solutions/IGOnDemand";
import InfoGenesisFPage from "./pages/Solutions/InfoGenesis";
import SalesFPage from "./pages/Solutions/Sales";
import AboutUs from "./pages/AboutUs";
import { HeaderInitial } from "./components/HeaderInitial";
import { IdleTimeoutProvider } from "./context/idleTimoutContext";
import NoDisplay from "./components/NoDisplay";
import CampusDining from "./pages/CampusDining";
import BookStorePage from "./pages/MainCampus/BookStore";
import ClassroomsPage from "./pages/MainCampus/Classrooms";
import ShippingPage from "./pages/MainCampus/Shipping";
import DiningHallPage from "./pages/CampusDining/DiningHall";
import MainCampusPage from "./pages/MainCampus";
import FoodCourtPage from "./pages/CampusDining/FoodCourt";
import StudentCenterPage from "./pages/StudentCenter";
import AthleticsPage from "./pages/Athletics";
import SeatsPage from "./pages/Athletics/Seats";
import ConcessionsPage from "./pages/Athletics/Concessions";
import DormRoomsPage from "./pages/DormRooms";


// directory profile

function App() {
  const { pathname } = useLocation();


  const firebaseConfig = {
    apiKey: "AIzaSyCVaAByzO-nOFY6XaVXLgTYHiGxlUWkZII",
    authDomain: "popshap-kiosks-dev.firebaseapp.com",
    projectId: "popshap-kiosks-dev",
    storageBucket: "popshap-kiosks-dev.appspot.com",
    messagingSenderId: "827903591200",
    appId: "1:827903591200:web:a3a3dd97574a553fb64d45",
    measurementId: "G-X3G2G8FZJ4",
  };

  const firebaseConfigProd = {
    apiKey: "AIzaSyBHhxW7040toMtuxfqJ15oDGO4xxCJpYEc",
    authDomain: "popshap-kiosks-live.firebaseapp.com",
    projectId: "popshap-kiosks-live",
    storageBucket: "popshap-kiosks-live.appspot.com",
    messagingSenderId: "167649908920",
    appId: "1:167649908920:web:ed844ee6dd3606f8257c4d",
    measurementId: "G-5G0NK754ZP",
  };

  const kioskProps: KioskContextProps = {
    projectId: "higher-education-responsive",
    clientId: "agilysys",
    layout: "vertical",
    logo: {
      src: "/assets/images/logo.png",
      width: 300,
      position: "center",
    },
  };

  const { slug } = useParams();
  const [kioskId, setKioskId] = useState<any>(null);
  useEffect(() => {
    if (pathname) {
      const kiosk = {
        kiosk: pathname.split('/')[1]
      }
      setKioskId({ ...kiosk })
    }

  }, [slug, pathname])
  
  return (
    <KioskProvider kiosk={kioskProps}>
      <FirebaseProvider
        config={
          process.env.REACT_APP_ENV === "production"
            ? firebaseConfigProd
            : firebaseConfig
        }
      >
        <AnalyticsProvider kioskId={kioskId}>
		    	<DataProvider>
            {/*pathname !== "/" && <Header />*/}            
            <NoDisplay />
		    		<Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/main-campus" element={<Outlet />}>
                <Route index element={<MainCampusPage />} />
                <Route path="gift-shop" element={<BookStorePage/>} />
                <Route path="classrooms" element={<ClassroomsPage />} />
                <Route path="shipping-receiving" element={<ShippingPage />} />
              </Route>
              <Route path="/campus-dining" element={<Outlet />}>
                <Route index element={<CampusDining />} />
                <Route path="dining-hall" element={<DiningHallPage />} />
                <Route path="food-court" element={<FoodCourtPage />} />
                <Route path="kitchen" element={<KitchenPage />} />
              </Route>
              <Route path="/athletics" element={<Outlet />}>
                <Route index element={<AthleticsPage />}/>
                <Route path="seats" element={<SeatsPage />} />
                <Route path="concessions" element={<ConcessionsPage />} />
              </Route>
              <Route path="/dorm-rooms" element={<DormRoomsPage />} />
              <Route path="/conference-and-ballroom" element={<StudentCenterPage />} />
              <Route path="/solutions/eatec" element={<EatecFPage />} />
              <Route path="/solutions/digital-menu" element={<DigitalMenuFPage />} />
              <Route path="/solutions/ig-kds" element={<IGKDSFPage />} />
              <Route path="/solutions/ig-kiosk" element={<IGKioskFPage />} />
              <Route path="/solutions/ig-on-demand" element={<IGOnDemandFPage />} />
              <Route path="/solutions/info-genesis" element={<InfoGenesisFPage />} />
              <Route path="/solutions/sales" element={<SalesFPage />} />
              <Route path="/aboutus" element={<AboutUs/>} />
              <Route path="/aboutus/agilysys" element={<AboutUs/>} />
            </Routes>
		    	</DataProvider>
		    </AnalyticsProvider>
      </FirebaseProvider>
    </KioskProvider>
  );
}

export default App;
